import React, { useState } from "react";
import styled from "styled-components";
import Copy from "../assets/copy.svg";
import Check from "../assets/check.svg";
import Rotate from "../assets/rotate-right.svg";

interface IFlag {
  value: string;
  prefix: string;
  onReset: () => void;
}

const Flag: React.FC<IFlag> = (props) => {
  const { value, prefix, onReset } = props;
  const [copyState, setCopyState] = useState<boolean>(false);

  const handleClick = () => {
    window.navigator.clipboard.writeText(`${prefix}{${value}}`);
    setCopyState(true);
    setTimeout(() => {
      setCopyState(false);
    }, 1000);
  };

  return (
    <FlagContainer>
      <FlagBox>
        <FlagText>
          {prefix}&#123;{value || "..."}&#125;
        </FlagText>
        <ButtonGroup>
          <IconButton onClick={handleClick}>
            <Icon src={copyState ? Check : Copy} alt="copy" />
          </IconButton>
          <IconButton onClick={onReset}>
            <Icon src={Rotate} alt="regenerate" />
          </IconButton>
        </ButtonGroup>
      </FlagBox>
    </FlagContainer>
  );
};

export default Flag;

const FlagContainer = styled.div`
  width: 100%;
`;

const FlagBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
  background: #111;
  border: 2px solid #00ff00;
  border-radius: 8px;
`;

const FlagText = styled.div`
  font-family: "Nunito", sans-serif;
  color: #00ff00;
  font-size: 1.2rem;
  font-weight: 700;
  word-break: break-all;
  flex: 1;
  letter-spacing: 1px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
`;

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: 1px solid #333;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #00ff00;
    background: rgba(0, 255, 0, 0.1);
  }
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
  filter: invert(100%);
`;
